import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { UserCheck, RefreshCw, LogOut } from 'lucide-react';
import { Button, message } from 'antd';
import axios from '../services/axiosConfig';
import './PendingActivation.css';

function BackgroundGrid() {
  return (
    <div
      className="pa-bg-grid"
      style={{
        backgroundImage:
          'linear-gradient(rgba(255,255,255,0.04) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.04) 1px, transparent 1px)',
        backgroundSize: '28px 28px',
        maskImage: 'radial-gradient(circle at 50% 55%, rgba(0,0,0,0.9), transparent 70%)',
      }}
    />
  );
}

function GradientOrbs() {
  return (
    <>
      <motion.div
        style={{
          position: 'absolute',
          top: '-6rem',
          left: '-6rem',
          width: '20rem',
          height: '20rem',
          borderRadius: '9999px',
          filter: 'blur(48px)',
          background: 'radial-gradient(circle, rgba(59,130,246,0.22), transparent 60%)',
        }}
        animate={{ scale: [1, 1.1, 1], opacity: [0.65, 0.9, 0.65] }}
        transition={{ duration: 12, repeat: Infinity, ease: 'easeInOut' }}
      />
      <motion.div
        style={{
          position: 'absolute',
          bottom: '-6rem',
          right: '-6rem',
          width: '24rem',
          height: '24rem',
          borderRadius: '9999px',
          filter: 'blur(48px)',
          background: 'radial-gradient(circle, rgba(52,211,153,0.2), transparent 60%)',
        }}
        animate={{ scale: [1, 0.9, 1], opacity: [0.6, 0.85, 0.6] }}
        transition={{ duration: 14, repeat: Infinity, ease: 'easeInOut' }}
      />
    </>
  );
}

export default function PendingActivationPage({ username, onActivated, onLogout }) {
  const [checking, setChecking] = useState(false);

  const handleCheckStatus = async () => {
    setChecking(true);
    try {
      const response = await axios.post('/api/v1/auth/refresh');
      const userData = response.data?.user;
      const newToken = response.data?.token;

      if (userData?.is_active && newToken) {
        message.success('Учётная запись активирована!');
        if (onActivated) {
          onActivated(newToken, userData);
        }
      } else {
        message.info('Учётная запись пока не активирована. Обратитесь к администратору.');
      }
    } catch {
      message.error('Не удалось проверить статус. Попробуйте войти снова.');
    } finally {
      setChecking(false);
    }
  };

  return (
    <div className="pa-root">
      <GradientOrbs />
      <BackgroundGrid />

      <motion.div
        initial={{ opacity: 0, y: 20, scale: 0.98 }}
        animate={{ opacity: 1, y: 0, scale: 1 }}
        transition={{ duration: 0.7, ease: 'easeOut' }}
        className="pa-center-card"
      >
        <div className="pa-icon-wrap">
          <UserCheck size={36} style={{ color: '#6ee7b7' }} />
        </div>

        <h1 className="pa-title">Спасибо за регистрацию!</h1>

        {username && (
          <div className="pa-username">{username}</div>
        )}

        <p className="pa-text">
          Ваша учётная запись создана, но для использования сервиса нужна активная запись.
          Для активации обратитесь к администратору.
        </p>

        <p className="pa-text" style={{ marginBottom: '2rem', fontSize: '0.9375rem', color: '#94a3b8' }}>
          После активации нажмите «Проверить статус» или войдите в систему заново.
        </p>

        <div className="pa-actions">
          <Button
            type="primary"
            size="large"
            icon={<RefreshCw size={18} />}
            loading={checking}
            onClick={handleCheckStatus}
          >
            Проверить статус
          </Button>
          <Button
            size="large"
            icon={<LogOut size={18} />}
            onClick={onLogout}
          >
            Выйти
          </Button>
        </div>
      </motion.div>
    </div>
  );
}
